<template>

    <!-- Raiz da aplicação Vuetify -->
    <v-app> 
        
        <!-- Área principal da aplicação -->
        <v-main> 
            
            <!-- Barra preta -->
            <v-toolbar
                color="black"
                dense
                flat
                :style="{
                    'border-top-left-radius': '12px',
                    'border-top-right-radius': '8px',
                    'position': 'fixed',
                    'top': '64px',
                    'left': modoBarraLateral ? '70px' : '260px',
                    'width': modoBarraLateral ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
                    'z-index': '999',
                    'transition': 'left 0.3s ease, width 0.3s ease'
                }"
            >      
                <v-toolbar-title class="white--text">Negociações Cadastradas: ({{ totalItems }})</v-toolbar-title> 
                <v-spacer />
                
                <!-- Botão para incluir novo registro de negociação  -->
                <v-spacer />
                <v-col cols="auto">

                    <v-tooltip text="Novo Registro Negociação" location="top">

                        <template #activator="{ props }">
                        <v-btn
                            v-bind="props"
                            icon
                            large
                            class="rounded-button"
                            style="background-color: #4CAF50;"
                            @click="novaNegociacao"
                        >
                            <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                        </template>

                    </v-tooltip>

                </v-col>
                
            </v-toolbar>

            <v-container fluid class="pa-4">
                
                <v-card class="pa-4" style="width: 100%;">

                    <!-- Campo de busca -->
                    <v-text-field
                        v-model="textoBusca"
                        label="Pesquisar"
                        placeholder="Digite sua busca..."
                        prepend-inner-icon="mdi-magnify"
                        variant="outlined"
                        :clearable="true"
                        @keyup.enter="carregaListaNegociacoes"
                        @click:clear="() => $nextTick(() => carregaListaNegociacoes())"
                        @update:modelValue="atualizaParamentrosBusca"
                        style="margin-top: 60px;" 
                    />
                                        
                    <!-- Tabela com os dados de negociação -->
                    <v-data-table-server
                        v-model:options="opcoesTabelaNegociacoes"
                        :headers="headersNegociacoes"
                        :items="listaNegociacoes"
                        :items-length="totalItems"
                        :loading="carregandoNegociacao"
                        @update:options="carregaListaNegociacoes"
                        class="elevation-2 rounded-lg"
                        :style="{ 
                            'font-family': 'Arial, sans-serif !important', 
                            'font-size': '11px !important' 
                        }"
                        >
                        
                        <!-- Slot para renderizar cada linha -->
                        <template #item="{ item }">

                            <tr
                                @click="editaDadosNegociacao(item)"
                                :class="{ 'linha-chamado-selecionada': linhaSelecionada.includes(item.id) }"
                                style="cursor: pointer;"
                            >
                            
                                <td>
                                    <v-btn 
                                        icon 
                                        variant="text" 
                                        color="green" 
                                        size="small"
                                        @click="editaDadosNegociacao(item)"
                                        title="Editar negociação"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </td>

                                <td>
                                    <a href="#" @click.prevent="editaDadosNegociacao(item)"> <!-- ✅ Corrigido -->
                                        {{ item.id }}
                                    </a>
                                </td>
                                <td>{{ item.nomeFantasia }}</td>
                                <td>{{ item.colaborador }}</td>
                                <td>{{ item.statusNegociacao }}</td>
                                <td>{{ item.dataHoraContato }}</td>
                                <td>{{ item.produtosInteresse }}</td>
                                <td>{{ item.descricao }}</td>
                            </tr>

                        </template>

                    </v-data-table-server>                    
                
                </v-card>

            </v-container>

            <!-- Modal/Dialog -->
            <v-dialog v-model="modalRegistroNegociacao.visible" max-width="80%" persistent>

                <v-form ref="formNegociacao">
                
                    <v-card>

                        <!-- Cabeçalho -->
                        <v-toolbar color="primary" dark>

                            <v-toolbar-title>
                                <v-icon left>mdi-handshake</v-icon>
                                Cadastro Negociações
                            </v-toolbar-title>
                            
                            <v-spacer></v-spacer>
                            <v-btn icon @click="fecharModal">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>

                        </v-toolbar>

                        <!-- Conteúdo do formulário -->
                        <v-card-text class="pa-6">

                            <v-row dense>

                                <!-- Campo Empresa com Autocomplete -->
                                <v-col cols="12" sm="6">

                                    <v-text-field 
                                        v-model="modalRegistroNegociacao.data.nomeFantasia" 
                                        label="Cliente"
                                        outlined
                                        :disabled="desabilitarCampoCliente"
                                        @input="autoCompletaNomeCliente"
                                        @keyup="manipuladorKeyUp"
                                        @keydown="handleKeyDown"
                                        clearable
                                        @click:clear="limpaCamposNegociacao(true)" 
                                        :rules="[rules.required]"                                   
                                    >
                                    </v-text-field>

                                    <!-- Lista de sugestões -->
                                    <v-list 
                                        v-if="sugestoesEmpresa.length && !desabilitarCampoCliente" 
                                        class="sugestoes-lista"
                                        style="max-height: 300px; overflow-y: auto; position: absolute; z-index: 1000; width: 100%; background: white;"
                                    >
                                        <v-list-item
                                            v-for="(cliente, index) in sugestoesEmpresa"
                                            :key="cliente.id"
                                            @click="selecionarCliente(cliente)"
                                            :class="{ 'sugestao-selecionada': index === indiceSelecionado }"
                                            style="cursor: pointer;"
                                            :rules="[rules.required]"
                                            :ref="el => setItemRef(el, index)"
                                            >
                                            <v-list-item-title>{{ cliente.nome }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                
                                </v-col>

                                <!-- Campo Solicitante -->
                                <v-col cols="12" sm="6">

                                    <v-select
                                        v-model="modalRegistroNegociacao.data.idColaborador"
                                        :items="modalRegistroNegociacao.data.colaborador"
                                        label="Solicitante"
                                        item-title="title"
                                        item-value="value"
                                        clearable
                                        :loading="carregandoColaboradores"
                                        @click:clear="limparColaborador"
                                        :rules="[rules.required]"
                                    >
                                        <template v-slot:prepend-item v-if="listaNegociacoes.length === 0 && !carregandoColaboradores">
                                        <v-list-item>
                                            <v-list-item-title class="text-grey">
                                            Nenhum colaborador disponível
                                            </v-list-item-title>
                                        </v-list-item>

                                        </template>

                                    </v-select>

                                </v-col>

                            </v-row>

                            <v-row dense>

                                <!-- Campo Data e Hora -->
                                <v-col cols="12" sm="4">

                                    <div class="form-field date-time-field">

                                        <v-menu
                                            v-model="menuData"
                                            :close-on-content-click="false"
                                            location="bottom"
                                            transition="scale-transition"
                                            :disabled="!modalRegistroNegociacao.data.nomeFantasia"                                            
                                        >
                                        
                                            <template v-slot:activator="{ props }">

                                                <v-text-field
                                                    v-model="modalRegistroNegociacao.data.dataHoraContato"
                                                    label="Data e Hora Contato"
                                                    placeholder="Selecione Data e Hora..."
                                                    hide-details="auto"
                                                    readonly
                                                    v-bind="props"
                                                    outlined 
                                                    :clearable="true"
                                                    :rules="[rules.required]"                                               
                                                    >
                                                    <template v-slot:append>
                                                        <v-icon icon="mdi-calendar-clock" />
                                                    </template>
                                                
                                                </v-text-field>
                                                
                                            </template>

                                            <v-card class="date-time-card">
                                                
                                                <v-card-text class="pa-0">

                                                    <v-tabs v-model="tabData" grow>
                                                        
                                                        <v-tab value="date">
                                                            <v-icon icon="mdi-calendar" />
                                                            Data
                                                        </v-tab>

                                                        <v-tab value="time">
                                                            <v-icon icon="mdi-clock" />
                                                            Hora
                                                        </v-tab>

                                                    </v-tabs>

                                                    <v-window v-model="tabData" class="date-time-window">
                                                        <v-window-item value="date">
                                                        <v-date-picker
                                                            v-model="dataSelecionada"
                                                            color="primary"
                                                            show-adjacent-months
                                                            locale="pt-BR"
                                                            @update:model-value="onDataSelecionada"
                                                        />
                                                        </v-window-item>

                                                        <v-window-item value="time">
                                                        <v-time-picker
                                                            v-model="horaSelecionada"
                                                            format="24hr"
                                                            color="primary"
                                                            scrollable
                                                        />
                                                        </v-window-item>
                                                    </v-window>

                                                    <v-card-actions class="pt-0 date-time-actions">
                                                        
                                                        <v-spacer />
                                                        <v-btn
                                                            color="primary"
                                                            variant="text"
                                                            @click="aplicarDataHora"
                                                            :disabled="!dataSelecionada"
                                                            >
                                                            Aplicar
                                                        </v-btn>
                                                        
                                                        <v-btn
                                                            color="secondary"
                                                            variant="text"
                                                            @click="menuData = false"
                                                            >
                                                            Cancelar
                                                        </v-btn>
                                                    
                                                    </v-card-actions>

                                                </v-card-text>

                                            </v-card>

                                        </v-menu>

                                    </div>

                                </v-col>

                                <!-- Campo Status Negociação -->
                                <v-col cols="12" sm="8">

                                    <v-select
                                        v-model="modalRegistroNegociacao.data.idStatusNegociacao"
                                        :items="listaStatusNegociacao"
                                        label="Status Negociação"
                                        item-title="title"
                                        item-value="value"
                                        :loading="carregandoStatusNegociacao"
                                        clearable
                                        :disabled="!modalRegistroNegociacao.data.nomeFantasia"
                                        :rules="[rules.required]"                                    
                                    ></v-select>

                                </v-col>
                            
                            </v-row>

                            <v-row dense>
                            
                                <!-- Campo Produtos de Interesse -->
                                <v-col cols="12" sm="12">

                                    <v-select
                                        v-model="modalRegistroNegociacao.data.produtosInteresse"
                                        :items="listaProdutosInteresse"
                                        item-title="title"
                                        item-value="value"
                                        multiple
                                        chips
                                        clearable
                                        :loading="carregandoProdutos"
                                        label="Produtos Interesse"
                                        :disabled="!modalRegistroNegociacao.data.nomeFantasia"
                                    >
                                        <template v-slot:selection="{ item, index }">

                                            <v-chip v-if="index < 2" class="me-1">
                                                <span>{{ item.title }}</span>
                                            </v-chip>

                                            <span v-if="index === 2" class="text-grey text-caption ms-1">
                                                +{{ modalRegistroNegociacao.data.produtosInteresse.length - 2 }} outros
                                            </span>

                                        </template>

                                    </v-select>

                                </v-col>
                            
                            </v-row>
                            
                            <v-row dense>

                                <!-- Campo Descrição -->
                                <v-col cols="12">

                                    <div class="quill-editor-wrapper quill-editor-redimensionavel">

                                        <label class="quill-label">Descrição Negociação</label>

                                        <QuillEditor
                                            v-model:content="modalRegistroNegociacao.data.descricao"
                                            content-type="html"
                                            theme="snow"
                                            :disabled="!modalRegistroNegociacao.data.nomeFantasia"
                                            :toolbar="[
                                                ['bold', 'italic', 'underline', 'strike'],
                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }]
                                            ]"
                                            :class="{ 'campos-desabilitados': !!modalRegistroNegociacao.data.nomeFantasia }"
                                        />
                                    </div>
                                    
                                </v-col>

                            </v-row>

                            <v-row dense>

                                <!-- Upload de Arquivos -->
                                <v-col cols="12">

                                    <v-file-input
                                        v-model="mostraAnexosNegociacao"
                                        multiple
                                        label="Selecione os arquivos"
                                        prepend-icon="mdi-paperclip"
                                        @change="manipuladorArquivoNegociacao"
                                        :loading="fazendoUploadNegociacao"
                                        :disabled="!modalRegistroNegociacao.data.nomeFantasia"
                                        :clearable="false"
                                        outlined
                                    >
                                        
                                        <template v-slot:selection="{ file }">

                                            <v-chip
                                            
                                                v-for="(fileObj, index) in arquivosAnexadosNegociacao"
                                                :key="fileObj.uniqueId || index"
                                                close
                                                class="ma-1"
                                                :color="fileObj.isExisting ? 'primary' : 'default'"
                                            >
                                                {{ fileObj.displayName }}

                                                <!-- Ícone para remover o arquivo -->
                                                <v-icon
                                                    class="ml-2"
                                                    color="red"
                                                    size="18"
                                                    @click.stop="abreModalConfirmacao(index)"
                                                    style="cursor: pointer;"
                                                >
                                                    mdi-close-circle
                                                </v-icon>

                                                <!-- Ícone para download, se o arquivo já existir -->
                                                <v-icon 
                                                    v-if="fileObj.isExisting" 
                                                    class="ml-1"
                                                    color="blue"
                                                    size="18"
                                                    @click.stop="baixarAnexo(fileObj,'anexos_negociacoes')"
                                                    style="cursor: pointer;"
                                                >
                                                    mdi-download
                                                </v-icon>

                                            </v-chip>
                                            
                                        </template>
                                    
                                    </v-file-input>

                                    <!-- Mensagens e Progresso -->
                                    <v-alert
                                        v-if="showMessageNegociacao"
                                        :type="messageType"
                                        density="compact"
                                        variant="tonal"
                                        class="mt-2"
                                    >
                                        {{ messageText }}
                                    </v-alert>

                                    <v-progress-linear
                                        v-if="fazendoUploadNegociacao"
                                        v-model="uploadProgressNegociacao"
                                        color="light-blue"
                                        height="10"
                                        class="mt-2"
                                    ></v-progress-linear>

                                </v-col>
                            
                            </v-row>

                        </v-card-text>

                        <v-card-actions class="flex-wrap">
                            
                            <v-spacer />
                            
                            <v-btn
                                class="ma-2 flex-grow-1 flex-sm-grow-0"
                                style="background-color: orange; color: white;"
                                @click="fecharModal"
                                >
                                <v-icon left>mdi-chevron-left</v-icon>
                                Retornar
                            </v-btn>

                            <v-btn
                                class="ma-2 flex-grow-1 flex-sm-grow-0"
                                style="background-color: #2196F3; color: white;"
                                @click="validarSalvarNegociacao('salvar')"
                                >
                                <v-icon left color="white">mdi-update</v-icon>
                                Salvar
                            </v-btn>

                            <v-btn
                                class="ma-2 flex-grow-1 flex-sm-grow-0"
                                outlined
                                style="background-color: white; border: 2px solid orange; color: orange;"
                                @click="validarSalvarNegociacao('salvar-retornar')"
                                >
                                <v-icon left color="orange">mdi-update</v-icon>
                                Salvar e Retornar
                            </v-btn>

                            <v-btn
                                class="ma-2 flex-grow-1 flex-sm-grow-0"
                                outlined
                                style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                                @click="validarSalvarNegociacao('salvar-novo')"
                                >
                                <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                                Salvar e Novo
                            </v-btn>

                        </v-card-actions>

                    </v-card>

                </v-form>

            </v-dialog>

            <!-- Modal de confirmação -->
            <ModalConfirmacao
                v-model="showModal"
                title="Confirma Remoção Anexo"
                :message="modalMessage"
                @confirm="executarRemocao"
                @cancel="cancelarRemocao"
            />

        </v-main>

    </v-app>

</template>

<script setup>

    // Importa as funcionalidades do Vue
    import { ref, onMounted, onBeforeUnmount, watch } from 'vue'

    // Importa axios para chamadas API
    import axios from 'axios'

    // Importa o editor de texto rico Quill
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa o event bus
    import { emitter } from '../utils/eventBus'
    
    import { useEditor } from '@/composables/useEditor'

    // Retorna um objeto com informações internas sobre o componente que está sendo executado no momento    
    import { getCurrentInstance } from 'vue'

    // Importa o componente do formulário de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa o componente do formulário de erros
    import { useErroStore } from '@/stores/erroStore'
    
    // Importa o componente do Snackbar
    import { useSnackbarStore } from '@/stores/snackbar'

    // Importa módulos do Vue Router
    import { useRoute } from 'vue-router'

    // Importa o componente do editor de texto enriquecido
    import { QuillEditor } from '@vueup/vue-quill'
    
    // Importa o CSS do editor de texto enriquecido
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa formulário de confirmação de operação
    import ModalConfirmacao from '@/components/ModalConfirmacao.vue'

    // importa rotina de limpeza de imagem do texto
    import { imagenUtils } from '@/utils/imagenUtils';

    
    // Importa o composable para upload de arquivos
    import { useUploadArquivos } from '@/composables/useUploadArquivos';

    // Desestrutura as funções do composable de upload de arquivos para facilitar o uso
    const { uploadArquivos, fazendoUpload } = useUploadArquivos();
    
    const isError = ref(false);
    
    // Importa composable de download de arquivos
    import { useDownloadArquivo } from '@/composables/useDownloadArquivo';
    
    // Importa o composable
    const { downloadArquivo } = useDownloadArquivo();
    
    // Estados locais para controle individual
    const baixandoArquivoId = ref(null);
    const progressoDownloadLocal = ref(0);
    
    // Carrega o endereço das api's
    const API_BASE_URL = import.meta.env.VITE_API_URL;

    // Permite acessar rotinas globais
    const { proxy } = getCurrentInstance()

    // Importa a store de login
    const loginStore = useLoginStore()

    // Estado local para o modo da barra lateral
    const modoBarraLateral = ref(false)

    // Importa a store de erros
    const erroStore = useErroStore()

    // Importa a store do snackbar
    const snackbar = useSnackbarStore()

    // Importa a rota atual
    const route = useRoute()

    // Controla a visibilidade do modal
    const showModal = ref(false)       
    
    // Mensagem do modal
    const modalMessage = ref('')        

    // Dados pendentes para remoção
    const pendingData = ref({           
        index: null,
        arquivo: null,
        tipo: null
    })

    // Define array contendo o campo que deve ser ordenado inicialmente e a direção
    const opcoesTabelaNegociacoes = ref({ 
        page: 1,
        itemsPerPage: -1,
        sortBy: ['negociacoes_empresas.id'],
        sortDesc: [false]
    })
    
    // Variável contendo os campos da lista de negociações
    const headersNegociacoes = [
        { title: 'Ações', text: 'Ações', value: 'actions', width: '1%', sortable: false },
        { title: 'Código', text: 'Código', value: 'id', width: '1%', sortable: true },
        { title: 'Empresa', text: 'Empresa', value: 'nomeFantasia', width: '10%', sortable: true },
        { title: 'Colaborador', text: 'Colaborador', value: 'colaborador', width: '10%', sortable: true },
        { title: 'Status', text: 'Status', value: 'statusNegociacao', width: '10%', sortable: true },        
        { title: 'Data Contato', text: 'Data Contato', value: 'dataHoraContato', width: '10%', sortable: true },
        { title: 'Produtos', text: 'Produtos', value: 'produtosInteresse', width: '10%', sortable: true },
        { title: 'Descrição', text: 'Descrição', value: 'descricao', width: '49%', sortable: true }
    ]

    // Define elemento da lista de Negociacao
    const listaNegociacoes = ref([])

    // 🔄 Dados da tabela
    const carregandoNegociacao = ref(false)
    
    // Total de itens da tabela
    const totalItems = ref(0)
    
    // Cria variável para elemento do texto de busca
    const textoBusca = ref('')

    // Refs para os dados principais
    const modalRegistroNegociacao = ref({
        visible: false,
        data: {
            id: 0,
            idEmpresa: null,
            nomeFantasia: '',
            idColaborador: null,
            colaborador: [],
            dataHoraContato: null,
            produtosInteresse: [],
            idStatusNegociacao: [],
            descricao: '',
            arquivosAnexadosNegociacao: []
        }
    })

    // Regras de validação
    const rules = {
        required: v => !!v || 'Campo obrigatório'
    }

    // Desabilita campo cliente caso a negociação já exista
    const desabilitarCampoCliente = ref(false)

    // Define o array com as sugestões do autocompleta
    const sugestoesEmpresa = ref([])
        
    // Adicione estas variáveis
    const indiceSelecionado = ref(-1)

    // Refs para controle do autocomplete dos colaboradores
    const carregandoColaboradores = ref(false)
    
    const linhaSelecionada = ref([])
    
    // Variáveis reativas
    const listaProdutosInteresse = ref([])
    const carregandoProdutos = ref(false)
    
    const listaStatusNegociacao = ref([])
    const carregandoStatusNegociacao = ref(false)
    
    const dataSelecionada = ref(null)
    const horaSelecionada = ref(null)
    
    const formNegociacao = ref(null)
    
    // Controle de estado
    const salvando = ref(false)

    // Variáveis para o datepicker
    const menuData = ref(false)
    const tabData = ref('date')

    const itemRefs = ref([])

    const mostraAnexosNegociacao = ref([]);
    const arquivosAnexadosNegociacao = ref([]);
    const fazendoUploadNegociacao = ref(false);
    const uploadProgressNegociacao = ref(0);    
    
    // Controle da mensagem
    const showMessageNegociacao = ref(false);
    
    const props = defineProps({
        modelValue: {
            type: String,
            default: ''
        }
    })

    // Define as variáveis do editor de textos
    const emit = defineEmits(['update:modelValue'])
    const editor = useEditor({
        content: props.modelValue,
        onUpdate: () => {
            emit('update:modelValue', editor.value.getHTML())
        }
    })

    // Variável para armazenar o ID da empresa (0 para nova empresa)
    const idNegociacaoRecebido = ref(0);
    
    // Salva o id da empresa
    idNegociacaoRecebido.value = Number(route.query.idStatusNegociacao) || 0;

    // Busca o modo da barra lateral vindo da lista
    modoBarraLateral.value = route.query.modoBarraLateral 

    // Inicializar linha atual - CORRIGIDO
    async function limpaCamposNegociacao(carregaProdutosStatus) {

        // Monta a data atual em formato brasileiro
        const dataAtual = proxy.$formataDataBrasil(new Date().toISOString());

        // Limpa campos do formulário
        modalRegistroNegociacao.value = {
            visible: true,
            data: {
                id: 0,
                idEmpresa: null,
                nomeFantasia: '',
                idColaborador: null,
                colaborador: [],
                dataHoraContato: dataAtual,
                produtosInteresse: [],
                idStatusNegociacao: [],
                descricao: '',
                arquivosAnexadosNegociacao: []
            }
        }
        
        // Limpa arrya de sugestões de empresa
        sugestoesEmpresa.value = [];

        // Limpa o indice de seleção
        indiceSelecionado.value = -1

        // Restante do código...
        tabData.value = 'date';

        // Habilida campos cliente
        desabilitarCampoCliente.value = false

        // Limpa lista de produtos
        listaProdutosInteresse.value = []

        // Limpa lista status negociação
        listaStatusNegociacao.value = []

        // Verifica se deve carrear produtos e status da negociação
        if(carregaProdutosStatus){
        
            // Busca todos produtos cadastrados
            const { data: dataProdutos } = await axios.get(`${API_BASE_URL}/administracao/carregaListaProdutos`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Carrega a lista de produtos cadastrados
            listaProdutosInteresse.value = dataProdutos.data
                .filter(produto => produto.ativo === 1)
                .map(produto => ({
                    title: produto.nome,
                    value: produto.idProduto
                })
            );

            // Busca todos status negociação cadastrados e ativos
            const { data: dataStatusNegociacao } = await axios.get(`${API_BASE_URL}/administracao/carregaListaStatusNegociacao`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Carrega a lista de status negociação
            listaStatusNegociacao.value = dataStatusNegociacao.data
                .filter(status => {
                    // Verifica se o objeto e o campo ativo existem
                    if (!status || status.ativo === undefined) return false;
                    // Converte para número para comparação segura
                    return Number(status.ativo) === 1;
                })
                .map(status => ({
                    title: status.nome,
                    value: status.idStatusNegociacao
                })
            );        
        }
    }
    
    // Função para tratar a digitação no campo de cliente
    async function autoCompletaNomeCliente() {
    
        // Limpa o índice selecionado quando o texto muda
        indiceSelecionado.value = -1
        
        const textoDigitado = modalRegistroNegociacao.value.data.nomeFantasia

        if (textoDigitado.length < 2) {
            sugestoesEmpresa.value = []
            indiceSelecionado.value = -1
            return
        }

        try {

            const resposta = await axios.get(`${API_BASE_URL}/operacao/autoCompletaCliente`, {
                params: { 
                    termo: textoDigitado 
                },
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            sugestoesEmpresa.value = resposta.data
                .filter(cliente =>
                    cliente.nomeFantasia?.toLowerCase().includes(textoDigitado.toLowerCase())
            )
            .map(cliente => ({
                id: cliente.id,
                nome: cliente.nomeFantasia
            }))
            
            // Resetar seleção quando novos resultados aparecem
            indiceSelecionado.value = -1

        } catch (erro) {
            erroStore.exibirErro(erro)
            sugestoesEmpresa.value = []
            indiceSelecionado.value = -1
        }        
    }    

    // Valida campos obrigatórios do cadastro de negociação se estão preenchidos
    async function validarSalvarNegociacao(funcaoRetorno) {
        
        // Valida o formulário de negociação
        const isValid = await formNegociacao.value?.validate(funcaoRetorno)
    
        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {
            
            // Chama a função para salvar os dados da negociação
            salvaNegociacao(funcaoRetorno)
            
        } else {
            snackbar.trigger('Preencha os campos obrigatórios.', 'error')
        }
    }

    // Salvar linha - VERSÃO COMPLETA
    async function salvaNegociacao(funcaoRetorno) {
        
        salvando.value = true;

        try {

            // Executa upload de arquivos
            // Executa upload dos arquivos anexados e obtém os dados dos arquivos salvos no servidor
            const resultadoUpload = await uploadArquivos(arquivosAnexadosNegociacao, {

                token: loginStore.token,
                onProgress: (progresso) => {
                    
                    // Atualiza o progresso para mostrar no v-progress-linear
                    uploadProgressNegociacao.value = progresso.percentual;
                }
            });
            
            // Se upload não retornou erro, salva os dados dos arquivos anexados
            if (resultadoUpload.status != 'erro') {

                // Extrai apenas os dados necessários
                const dadosAnexos = arquivosAnexadosNegociacao.value.map(arquivo => ({
                    filePath: arquivo.filePath,
                    filename: arquivo.filename,
                    originalName: arquivo.originalName,
                    size: arquivo.size,
                    serverName: arquivo.serverName,
                    uniqueId: arquivo.uniqueId             
                }));

                modalRegistroNegociacao.value.arquivosAnexosNegociacao = dadosAnexos;

            } else {
                modalRegistroNegociacao.value.arquivosAnexosNegociacao = []
            }

            // Monta variável com os dados a serem salvos
            const dadosSalvar = {
                id: modalRegistroNegociacao.value.data.id,
                idEmpresa: modalRegistroNegociacao.value.data.idEmpresa,
                idColaborador: modalRegistroNegociacao.value.data.idColaborador,
                idStatusNegociacao: modalRegistroNegociacao.value.data.idStatusNegociacao,
                dataHoraContato: modalRegistroNegociacao.value.data.dataHoraContato,
                produtosInteresse: modalRegistroNegociacao.value.data.produtosInteresse || [],
                descricao: modalRegistroNegociacao.value.data.descricao,
                arquivosAnexosNegociacao: modalRegistroNegociacao.value.arquivosAnexosNegociacao 
            }
            
            // Salva registro da negociação
            const resposta = await axios.post(`${API_BASE_URL}/operacao/salvaNegociacao/${modalRegistroNegociacao.value.data.id}`, dadosSalvar, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Salva id do chamado retornado pela API
            modalRegistroNegociacao.value.data.id = resposta.data.idNegociacao;

            // Busca imagens que foram inseridas no editor
            const imagensEditor = resposta.data.imagensEditor

            // Verifica se a resposta é um array indicando que existem imagens no editor
            if (Array.isArray(imagensEditor) && imagensEditor.length > 0) {
                
                // Mapeia as novas imagens do editor
                const novasImagens = imagensEditor.map(imagem => ({
                    filePath: imagem.filePath,
                    filename: imagem.filename,
                    originalName: imagem.originalName,
                    size: imagem.size,
                    serverName: imagem.serverName,
                    uniqueId: imagem.uniqueId,
                    isExisting: true,
                    displayName: imagem.displayName || `${imagem.originalName} (${(imagem.size / 1024).toFixed(2)} KB)`,
                    raw: null
                }));
                
                // Filtra apenas as imagens que ainda não existem (verificando por uniqueId)
                const imagensNaoExistentes = novasImagens.filter(novaImagem => 
                    !arquivosAnexadosNegociacao.value.some(existente => 
                        existente.uniqueId === novaImagem.uniqueId
                    )
                );
                
                // Adiciona apenas as imagens novas ao array existente
                if (imagensNaoExistentes.length > 0) {
                    arquivosAnexadosNegociacao.value = [
                        ...arquivosAnexadosNegociacao.value,
                        ...imagensNaoExistentes
                    ];
                }
            }

            // Atualiza o v-file-input (mostraAnexosChamado) com todos os arquivos
            if (arquivosAnexadosNegociacao.value && arquivosAnexadosNegociacao.value.length > 0) {
                
                mostraAnexosNegociacao.value = arquivosAnexadosNegociacao.value.map(arquivo => ({
                    name: arquivo.originalName,
                    size: arquivo.size,
                    type: 'application/octet-stream',
                    lastModified: Date.now()
                }));
            }

            // Salva dados da imagem nas variáveis do modal
            modalRegistroNegociacao.value.data.arquivosAnexadosNegociacao = mostraAnexosNegociacao.value;
            
            snackbar.trigger('Negociação salva com sucesso!', 'success');
            
            // Carrega lista de negociações
            await carregaListaNegociacoes();
            
            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                fecharModal()
            } else {
                await limpaCamposNegociacao(true);
            }

            
        } catch (erro) {
            erroStore.exibirErro(erro);
        } finally {
            salvando.value = false;
        }        
    };
    
    // Função para verificar antes de apagar o conteúdo do campo de cliente
    async function manipuladorKeyUp(event) {
    
        // Verifica se a tecla pressionada foi Backspace ou Delete
        if (event.key === 'Backspace' || event.key === 'Delete') {
            
            // Se o campo de cliente estiver vazio, limpa os dados da empresa cliente
            if (modalRegistroNegociacao.value.data.nomeFantasia === '') {
                await limpaCamposNegociacao(true)
            }
        }
    }

    // Executa download do arquivo anexo apontado pela variável fileObj, 
    // usando a função downloadArquivo do composable useDownloadArquivo
    const baixarAnexo = async (fileObj, tabela) => {

        // Verifica se este arquivo específico já está baixando
        if (baixandoArquivoId.value === fileObj.uniqueId) return;
        
        // Marca apenas este arquivo como baixando
        baixandoArquivoId.value = fileObj.uniqueId;
        progressoDownloadLocal.value = 0;
        
        try {
            await downloadArquivo(fileObj, tabela, {

                showProgress: true,
                onProgress: (percentual) => {
                    // Atualiza o progresso APENAS deste arquivo
                    progressoDownloadLocal.value = percentual;
                }
            });
            
        } finally {
            baixandoArquivoId.value = null;
            progressoDownloadLocal.value = 0;
        }
    };

    // Esta rotina abre o modal de confirmação
    const abreModalConfirmacao = (index, tipo) => {

        // Seleciona a lista correta baseado no tipo
        let listaArquivos

        // Se a lista de arquivos anexos do chamado não está definida sai da rotina
        if (!arquivosAnexadosNegociacao?.value) {
            return
        }

        // Salva a lista de anexos das negociações
        listaArquivos = arquivosAnexadosNegociacao.value

        // Valida se o índice existe
        if (index < 0 || index >= listaArquivos.length) {
            return
        }
        
        // Salva o arquivo selecionado
        const arquivo = listaArquivos[index]
        
        // Valida se o arquivo existe
        if (!arquivo) {
            return
        }
        
        // Define a mensagem baseada no tipo de arquivo
        const nomeArquivo = arquivo.name || 'Arquivo'
        
        modalMessage.value = arquivo.uniqueId 
            ? `Deseja Remover "${nomeArquivo}" do Servidor Permanentemente?`
            : `Deseja Remover "${nomeArquivo}" da Lista de Anexos?`
        
        // Guarda os dados pendentes
        pendingData.value = {
            index: index,
            arquivo: arquivo,
            tipo: tipo
        }
        
        // Abre o modal
        showModal.value = true
    }

    // Executa a remoção após confirmação
    const executarRemocao = async () => {

        if (pendingData.value.index !== null) {

            // Chama rotina de remoção passando o indice, arquivo e tipo
            await executaRemocaoAnexo(
                pendingData.value.index, 
                pendingData.value.arquivo, 
                pendingData.value.tipo
            )

            // Limpa os dados pendentes
            pendingData.value = {
                index: null,
                arquivo: null,
                tipo: null
            }
        }
    }

    // Trata botão de confirmação do cancelamento
    const cancelarRemocao = () => {
        
        pendingData.value = {
            index: null,
            arquivo: null,
            tipo: null
        }
    }

    // Função real de remoção
    const executaRemocaoAnexo = async (index, arquivo, tipo) => {

        // Define as configurações baseado no tipo
        const config =  {

            listaArquivos: arquivosAnexadosNegociacao,
            tabelaApi: 'anexos_negociacoes',
            mostraAnexos: mostraAnexosNegociacao,
            nomeContexto: 'negociacao'
        } 

        // Verifica se o índice ainda é válido
        if (index < 0 || index >= config.listaArquivos.value.length) return
        
        // Busca o arquivo atualizado na lista
        const arquivoParaRemover = config.listaArquivos.value[index]
        
        try {

            // Verifica se o arquivo já tem uniqueId (já salvo no servidor)
            if (arquivoParaRemover.uniqueId) {

                // Chama API para remover do servidor
                await axios.delete(
                    `${API_BASE_URL}/operacao/excluirArquivoAnexado/${arquivoParaRemover.uniqueId}/${config.tabelaApi}`,
                    {
                        headers: {
                            Authorization: `Bearer ${loginStore.token}`
                        }
                    }
                )
                
                // Busca texto do chamado
                const textoNgociacao = modalRegistroNegociacao.value.data.descricao;

                // Remove a imagem apontada por arquivoParaRemover.filePath do texto
                const textoChamadoLimpo = imagenUtils.removeImagemTexto(textoNgociacao, arquivoParaRemover.filePath)

                // Salva texto no editor sem a imagem
                modalRegistroNegociacao.value.data.descricao = textoChamadoLimpo;                
            }
            
            // Remove o arquivo da lista local
            config.listaArquivos.value.splice(index, 1);
            
            // Atualiza a lista de visualização se existir
            if (config.mostraAnexos.value && typeof config.mostraAnexos.value === 'object') {
                config.mostraAnexos.value = [...config.listaArquivos.value]
            }            
            
        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    }

    // Função para lidar com teclas
    async function handleKeyDown(event) {

        if (event.key === 'Backspace' || event.key === 'Delete') {
            if (modalRegistroNegociacao.value.data.nomeFantasia.length <= 1) {
                await limpaCamposNegociacao(true)
                return
            }           
        }

        if (!sugestoesEmpresa.value.length) return
        
        switch(event.key) {

            case 'ArrowDown':
                event.preventDefault()
            
                if (sugestoesEmpresa.value.length > 0) {

                    if (indiceSelecionado.value >= sugestoesEmpresa.value.length - 1) {
                        indiceSelecionado.value = 0
                    } else {
                        indiceSelecionado.value++
                    }
                    // Rola para o item selecionado
                    scrollToSelectedItem()
                }
                break
                
            case 'ArrowUp':
                event.preventDefault()
                if (sugestoesEmpresa.value.length > 0) {
                    if (indiceSelecionado.value <= 0) {
                        indiceSelecionado.value = sugestoesEmpresa.value.length - 1
                    } else {
                        indiceSelecionado.value--
                    }
                    // Rola para o item selecionado
                    scrollToSelectedItem()
                }
                break
                
            case 'Enter':
                if (indiceSelecionado.value >= 0 && indiceSelecionado.value < sugestoesEmpresa.value.length) {
                    event.preventDefault()
                    selecionarCliente(sugestoesEmpresa.value[indiceSelecionado.value])
                }
                break
                
            case 'Escape':
                sugestoesEmpresa.value = []
                indiceSelecionado.value = -1
                break
        }
    }

    // Se o campo foi limpo, recarrega a lista de Negociacao
    function atualizaParamentrosBusca(novoValor) {
        if (!novoValor) {
            carregaListaNegociacoes(novoValor)
        }
    }
    
    // Função para quando uma data é selecionada
    function onDataSelecionada(data) {
        
        // Se não há hora definida, define uma padrão (ex: 12:00)
        if (!horaSelecionada.value) {
            horaSelecionada.value = '14:00';
        }
        
        // Muda automaticamente para a aba de hora
        setTimeout(() => {
            tabData.value = 'time';
        }, 100);
    }    
    
    function setItemRef(el, index) {
        if (el) {
            itemRefs.value[index] = el
        }
    }

    // Função para rolar até o item selecionado
    function scrollToSelectedItem() {

        nextTick(() => {

            const selectedElement = document.querySelector('.sugestao-selecionada')
            if (selectedElement) {
                selectedElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                })
            }
        })
    }

    // Função que lê o tamanho da barra no localStorage e aplica na 
    function ajustaBarraPretaTopo(){
        
        if (localStorage.getItem('tamanhoBarraLaterar') == 'true'){
            modoBarraLateral.value = true
        } else{
            modoBarraLateral.value = false
        }
    }
    
    // Esta rotina é chamada quando um cliente é selecionado na lista de sugestões
    async function selecionarCliente(empresa) {

        try{

            // Atualiza o campo visível com o nome
            modalRegistroNegociacao.value.data.nomeFantasia = empresa.nome

            // Armazena o ID da empresa escolhido, se for necessário para outra lógica
            modalRegistroNegociacao.value.data.idEmpresa = empresa.id

            // Limpar sugestões após seleção
            sugestoesEmpresa.value = []
            indiceSelecionado.value = -1            

            // Carrega lista d ecolaboradores
            carregarColaboradores(empresa.id);

            // Busca ultimo dado da negociação
            const { data: dataNegociacoes } = await axios.get(`${API_BASE_URL}/operacao/carregaUltimaNegocicaoEmpresa/${empresa.id}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Verifica se retornou erro indicando que ainda não existe negociação cadastrada para cliente selecionado
            if (dataNegociacoes.erro == true){
                snackbar.trigger(dataNegociacoes.mensagem,'warning');
                return;
            }
            
            // Se encontrou ultima negociação carrega dados no modal
            if (dataNegociacoes.length != 0){

                // Zera o id da negociação indicando que é um registro novo
                modalRegistroNegociacao.value.data.id = 0
                
                // Aponta para o colaborador cadastrado
                modalRegistroNegociacao.value.data.idColaborador = dataNegociacoes.data.idColaborador;
                
                // Aponta para o status da negociação vindos da api
                modalRegistroNegociacao.value.data.idStatusNegociacao = dataNegociacoes.data.idStatusNegociacao

                // Carrega os produtos de interesse cadastrados 
                modalRegistroNegociacao.value.data.produtosInteresse = dataNegociacoes.data.produtosInteresse.map(produto => {                    
                        
                        const produtoCompleto = listaProdutosInteresse.value.find(
                            protutoEncontrado => protutoEncontrado.value === produto.idProduto
                        );
                        return produtoCompleto ? produtoCompleto.value : null;
                    }
                )
                
                // Verifica se a resposta é um array indicando que existem arquivos anexados
                if (Array.isArray(dataNegociacoes.data.arquivosAnexadosNegociacao)) {

                    const arquivosExistentes = dataNegociacoes.data.arquivosAnexadosNegociacao.map(arquivo => ({
                        name: arquivo.name,
                        size: arquivo.size,
                        serverName: arquivo.serverName,
                        path: arquivo.path,
                        isExisting: true,
                        displayName: `${arquivo.name}`,
                        uniqueId: arquivo.uniqueId,
                        raw: null // Arquivos existentes não têm o objeto File original
                    }));
                    
                    // uploadedFiles.value = arquivosExistentes;
                    arquivosAnexadosNegociacao.value = [...arquivosExistentes, ...arquivosAnexadosNegociacao.value.filter(filtro => !filtro.isExisting)];
                    
                    // Atualize o v-model do v-file-input
                    mostraAnexosNegociacao.value = arquivosExistentes.map(aquivoVfile => ({
                        name: aquivoVfile.name,
                        size: aquivoVfile.size,
                        type: 'application/octet-stream', // Tipo genérico para arquivos existentes
                        lastModified: Date.now()
                    }));
                }

                // Desabilita o campo do cliente
                desabilitarCampoCliente.value = true
            }

        } catch (erro) {
            erroStore.exibirErro(erro)
        }   

        // Limpa e esconde as sugestões
        sugestoesEmpresa.value = []
    }
    
    // Esta função é chamada pelo X do campo colaborador para limpar
    const limparColaborador = () => {
        modalRegistroNegociacao.value.data.colaborador = []
    }
    
    // Esta função fecha o formulário modal de negociações
    const fecharModal = async () => {
        
        // Limpa campos do modal
        await limpaCamposNegociacao(false)

        // Torna modal invisível
        modalRegistroNegociacao.value.visible = false
    }

    // Salva a data selecionada
    const aplicarDataHora = () => {

        if (dataSelecionada.value && horaSelecionada.value) {
            
            // Define hora padrão se não houver seleção
            const hora = horaSelecionada.value || '14:00'
            
            // Converte a data selecionada (que vem no formato YYYY-MM-DD)
            const dataObj = new Date(dataSelecionada.value)
            
            // Adiciona a hora
            const [horas, minutos] = hora.split(':')
            dataObj.setHours(parseInt(horas), parseInt(minutos))
            
            // Formata para dd/mm/yyyy hh:mm
            const dia = String(dataObj.getDate()).padStart(2, '0')
            const mes = String(dataObj.getMonth() + 1).padStart(2, '0')
            const ano = dataObj.getFullYear()
            
            const dataHoraFormatada = `${dia}/${mes}/${ano} ${hora}`
            
            // Armazena o resultado onde você precisar
            modalRegistroNegociacao.value.data.dataHoraContato = dataHoraFormatada

            // Fecha o menu
            menuData.value = false
            
            return dataHoraFormatada
            
        } else {
            snackbar.trigger('Selecione uma data primeiro', 'error')
            return null
        }
    }
        
    // Função para carregar colaboradores
    const carregarColaboradores = async (idEmpresa) => {

        // Se não recebeu o id da empresa, sai da rotina
        if (!idEmpresa) {
            return
        }
        
        // Liga indicação de que está carregando colaborador
        carregandoColaboradores.value = true
        
        try {

            // Busca todos colaboradores da empresa apontada por idEmpresa
            const { data: dataContatos } = await axios.get(`${API_BASE_URL}/operacao/buscaColaboradoresCliente/${idEmpresa}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Garante que o retorno seja um array
            const contatos = Array.isArray(dataContatos) ? dataContatos : dataApi.retornoApi || []
            
            // Transforma os contatos no formato que o v-select precisa
            modalRegistroNegociacao.value.data.colaborador = contatos.map(contato => ({
                value: contato.id, 
                title: contato.nome
            }))
            
        } catch (erro) {

            carregandoColaboradores.value = false
            erroStore.exibirErro(erro)
            
        } finally {
            carregandoColaboradores.value = false
        }
    }

    // Carregar do localStorage - CORRIGIDO
    const carregaListaNegociacoes = async () => {

        try {

            // Verifica se não está carregando a lista de negociações
            if (carregandoNegociacao.value == false){

                // liga indicação de carga da lista de negociações
                carregandoNegociacao.value = true;
                
                // Blindagem contra estados intermediários
                const sortArray = Array.isArray(opcoesTabelaNegociacoes.value?.sortBy) 
                    ? opcoesTabelaNegociacoes.value.sortBy 
                    : []
                
                const primeiraOrdenacao = sortArray.length ? sortArray[0] : null

                // // 2) Defaults estáveis (sem jamais acessar [0] de algo indefinido)
                const ordenacaoPor = primeiraOrdenacao?.key ?? 'negociacoes_empresas.id'
                const direcaoOrdenacao = primeiraOrdenacao?.order ?? 'desc'
                
                // Extrai paginação
                const paginaAtual = opcoesTabelaNegociacoes.value.page ?? 1
                const itensPorPagina = opcoesTabelaNegociacoes.value.itemsPerPage ?? 10
                
                // limpa lista
                listaNegociacoes.value = [];

                // Reseta valor total de registros
                totalItems.value = 0;
                
                // Chama api para carregar a lista de negociações passando parâmetros de ordenação e texto para busca
                const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaListaNegociacoes`, {
                    params: { 
                        textoBusca: textoBusca.value,
                        ordenacaoPor: ordenacaoPor || 'negociacoes_empresas.id',  
                        direcaoOrdenacao: direcaoOrdenacao || 'desc',
                        paginaAtual: paginaAtual,
                        itensPorPagina: itensPorPagina                        
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                });
                
                // Garente que o retorno seja um array
                const retorno = data.data || [];

                // Verifica se encontrou dados
                if (retorno.length > 0) {

                    // Formata dados para inserir na tabela
                    listaNegociacoes.value = retorno.map(item => ({
                        id: item.id,
                        nomeFantasia: item.nomeFantasia,
                        colaborador: item.colaborador,
                        statusNegociacao: item.statusNegociacao,
                        dataHoraContato: item.dataHoraContato ? 
                            new Date(item.dataHoraContato).toLocaleString('pt-BR') : '',
                        produtosInteresse: item.produtosInteresse,
                        descricao: removerHTML(item.descricao),
                        idEmpresa: item.idEmpresa,
                        idColaborador: item.idColaborador
                    }));
                    
                    totalItems.value = retorno.length;
                }
            }

        } catch (erro) {                
            carregandoNegociacao.value = false;
            erroStore.exibirErro(erro);
        } finally {
            carregandoNegociacao.value = false;
        }
    };

    // Esta função é chamada pelo botão verde localizado na barra preta do formulário
    const novaNegociacao = async () => {
    
        // Limpa campos do formulário
        await limpaCamposNegociacao(true);

        // Mostra formulário modal
        modalRegistroNegociacao.value.visible = true
    }

    // Formata o tamanho do arquivo
    const formatFileSize = (bytes) => {
        if (!bytes || isNaN(bytes)) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };
    
    // Função para atualizar o v-model com os arquivos atuais do chamado
    const manipuladorArquivoNegociacao = (event) => {

        // Verifica se o evento contém arquivos, sai da função se não houver
        const arquivoEntrada = event.target.files;

        if (!arquivoEntrada || arquivoEntrada.length === 0) return;

        // Converte lista de arquivos para array e filtra arquivos já selecionados
        const novoArquivo = Array.from(arquivoEntrada).filter(arquivo => {

                // Verifica se o arquivo NÃO está já na lista arquivosAnexadosChamado
                return !arquivosAnexadosNegociacao.value.some(
                    existingFile => 
                        existingFile.name === arquivo.name && 
                        existingFile.size === arquivo.size
                );
            
        }).map(arquivo => ({
                
            name: arquivo.name,
            size: arquivo.size,
            type: arquivo.type || 'application/octet-stream',
            lastModified: arquivo.lastModified || Date.now(),
            raw: arquivo,       
            uniqueId: null,     
            isExisting: false,
            displayName: `${arquivo.name} (${formatFileSize(arquivo.size)})`,
            serverName: null    

        }));

        // Atualiza a lista de arquivos mostrados
        if (novoArquivo.length > 0) {

            // Salva o novo arquivo na lista de todos os anexos
            arquivosAnexadosNegociacao.value = [...arquivosAnexadosNegociacao.value, ...novoArquivo];
            
            // Atualiza o displayFiles para mostrar os novos arquivos
            snackbar.trigger(`${novoArquivo.length} Novo(s) Arquivo(s) Adicionado(s)`, 'success');

        } else {
            
            // Todos os arquivos selecionados já estão na lista
            snackbar.trigger('Arquivo Já Está Na Seleção', 'warning');
        }

        event.target.value = '';
    };

    // Download de arquivo existente
    const downloadArquivoNegociacao = async (file) => {

        // Verifica se o arquivo tem um nome de servidor válido
        if (!file.serverName) return;
                    
        // Retira nome do arquivo do caminho
        const nomeArquivo = file.path.split('/').pop();

        try{

            // Faz a requisição para baixar o arquivo
            fetch(`${API_BASE_URL}/download/${nomeArquivo}`).then((res) => {
            
                if (!res.ok) throw new Error('Erro ao baixar');       
                
                return res.blob();
            
            }).then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = file.name || nomeArquivo;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            });

        } catch (erro) {            
            erroStore.exibirErro(erro)
        }
    };

    // Editar registro
    const editaDadosNegociacao = async (item) => {
        
        try{

            // Limpa campos referentes a negociação
            await limpaCamposNegociacao(true);

            // Carrega lista d ecolaboradores
            carregarColaboradores(item.idEmpresa);
            
            // Busca dados da negociação apontada por item.id
            const { data: dataNegociacoes } = await axios.get(`${API_BASE_URL}/operacao/carregaNegociacao/${item.id}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Salva o id da negociação selecionada
            modalRegistroNegociacao.value.data.id = dataNegociacoes.data.id
            
            // Salva o id e nome da empresa referente a negociação
            modalRegistroNegociacao.value.data.idEmpresa = dataNegociacoes.data.idEmpresa            
            modalRegistroNegociacao.value.data.nomeFantasia = dataNegociacoes.data.nomeFantasia

            // Aponta para o colaborador cadastrado
            modalRegistroNegociacao.value.data.idColaborador = dataNegociacoes.data.idColaborador;
            
            // Salva a data e hora convertidas para padrão brasileiro
            modalRegistroNegociacao.value.data.dataHoraContato = proxy.$formataDataBrasil(dataNegociacoes.data.dataHoraContato)
            
            // Aponta para o status da negociação vindos da api
            modalRegistroNegociacao.value.data.idStatusNegociacao = dataNegociacoes.data.idStatusNegociacao

            // Carrega os produtos de interesse cadastrados 
            modalRegistroNegociacao.value.data.produtosInteresse = dataNegociacoes.data.produtosInteresse.map(produto => {                    
                    
                    const produtoCompleto = listaProdutosInteresse.value.find(
                        protutoEncontrado => protutoEncontrado.value === produto.idProduto
                    );
                    return produtoCompleto ? produtoCompleto.value : null;
                }
            )
            
            // Salva descrição da negociação
            modalRegistroNegociacao.value.data.descricao = dataNegociacoes.data.descricao            

            // Verifica se a resposta é um array indicando que existem arquivos anexados
            if (Array.isArray(dataNegociacoes.data.arquivosAnexadosNegociacao)) {

                const arquivosExistentes = dataNegociacoes.data.arquivosAnexadosNegociacao.map(arquivo => ({
                    filePath: arquivo.filePath,
                    filename: arquivo.filename,
                    originalName: arquivo.originalName,
                    size: arquivo.size,
                    serverName: arquivo.serverName,
                    uniqueId: arquivo.uniqueId,
                    isExisting: true,
                    displayName: `${arquivo.displayName || arquivo.originalName} (${(arquivo.size / 1024).toFixed(2)} KB)`,
                    raw: null
                }));
                
                // uploadedFiles.value = arquivosExistentes;
                arquivosAnexadosNegociacao.value = [...arquivosExistentes, ...arquivosAnexadosNegociacao.value.filter(filtro => !filtro.isExisting)];
                
                // Atualize o v-model do v-file-input
                mostraAnexosNegociacao.value = arquivosExistentes.map(aquivoVfile => ({
                    name: aquivoVfile.name,
                    size: aquivoVfile.size,
                    type: 'application/octet-stream', // Tipo genérico para arquivos existentes
                    lastModified: Date.now()
                }));
            }

            // Desabilita o campo do cliente
            desabilitarCampoCliente.value = true

        } catch(erro){
           erroStore.exibirErro(erro);     
        }
    };

    // Remove um arquivo anexo do negociação
    const removeAnexoNegociacao = async (index) => {

        // Verifica se o índice é válido
        if (index < 0 || index >= arquivosAnexadosNegociacao.value.length) return;
        
        // Busca o arquivo a ser removido
        const arquivoParaRemover = arquivosAnexadosNegociacao.value[index];

        // Mostra mensagem de sucesso
        snackbar.trigger(`Arquivo ${arquivoParaRemover.displayName} Removido Com Sucesso!`, 'success');

        // Remove o arquivo da lista local
        arquivosAnexadosNegociacao.value.splice(index, 1);

        // Remove o arquivo da lista negociações
        mostraAnexosNegociacao.value = [...arquivosAnexadosNegociacao.value];
        
        // Se o arquivo já foi salvo, exclui
        if (arquivoParaRemover.uniqueId){

            // Chama API para remover o arquivo do servidor
            const retorno = await axios.delete(`${API_BASE_URL}/operacao/excluirArquivoAnexoNegociacao/${arquivoParaRemover.uniqueId}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });
        }
    };

    // Esta rotina remove os comandos htlm da descrição para mostrar texto puro na lista
    const removerHTML = (texto) => {

        if (!texto) return ''
        
        // Cria um elemento temporário
        const div = document.createElement('div')
        div.innerHTML = texto
        
        // Retorna apenas o texto, sem as tags
        return div.textContent || div.innerText || ''
    }

    // Sincroniza o conteúdo entre o componente pai e o editor Tiptap
    watch(() => props.modelValue, (value) => {
        
        const isSame = editor.value.getHTML() === value
        if (isSame) return

        editor.value.commands.setContent(value, false)
    })

    // Watch para quando o menu fecha
    watch(menuData, (novoValor) => {

        if (!novoValor) {

            // Reseta as abas quando o menu fecha
            setTimeout(() => {
                tabData.value = 'date'
            }, 300)
        }
    })

    // Rotina chamada quando o formulário é inicializado
    onMounted(() => {
        
        // Listener para mudanças do drawer
        const manipuladorMudancaTamanho = (data) => {

            // Salva valor emitido pelo botão de minimizar/maximizar a barra lateral
            localStorage.setItem('tamanhoBarraLaterar', data)            
            
            // Ajusta barra preta do topo do formulário
            ajustaBarraPretaTopo()
        }
    
        // Adiciona listener para mudanças do drawer
        emitter.on('mudancaBarraLateral', manipuladorMudancaTamanho)

        // Ajusta a barra preta do topo do fomulário com o valor do localStorage
        ajustaBarraPretaTopo()

        // Carrega lista de negociações
        carregaListaNegociacoes()
    })

    // Rotina chamada antes de desmontar o componente
    onBeforeUnmount(() => {

        // Limpar listener
        emitter.off('mudancaBarraLateral')
    })

</script>

<style scoped>

    .sugestao-selecionada {
        background-color: #e3f2fd !important;
        color: #1976d2 !important;
    }

    .linha-chamado-selecionada {
        background-color: #e6e6e6;
        color: rgb(15, 15, 15);
    }

    .form-container {
        width: 100%;
    }

    .ajusteCorpoFonte :deep(.v-field__input) {
        font-size: 11px !important; /* Tamanho menor */
    }

    .cadastro-negociacoes {
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        min-height: 100vh;
        padding: 20px;
    }

    .css-negocicao {
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }

    .form-grid-proportional {
        display: flex;
        gap: 12px;
        align-items: start;
        flex-wrap: wrap;
        width: 100%;
    }

    .form-field {
        min-width: 0;
        flex-shrink: 0;
    }

    .width-10 {
        flex: 0 0 calc(10% - 11px);
        max-width: calc(10% - 11px);
    }

    .width-20 {
        flex: 0 0 calc(20% - 11px);
        max-width: calc(20% - 11px);
    }

    .width-25 {
        flex: 0 0 calc(25% - 11px);
        max-width: calc(25% - 11px);
    }

    .width-40 {
        flex: 0 0 calc(40% - 11px);
        max-width: calc(40% - 11px);
    }

    .width-50 {
        flex: 0 0 calc(50% - 11px);
        max-width: calc(50% - 11px);
    }

    .date-time-field {
        position: relative;
    }

    .date-time-input {
        cursor: pointer;
    }

    .table-container {
        width: 100%;
        overflow-x: auto;
    }

    .proportional-table {
        width: 100%;
        table-layout: fixed;
    }

    .column-width-10 {
        width: 10%;
        min-width: 80px;
    }

    .column-width-20 {
        width: 20%;
        min-width: 120px;
    }

    .column-width-25 {
        width: 25%;
        min-width: 150px;
    }

    .column-width-40 {
        width: 40%;
        min-width: 180px;
    }

    .column-width-50 {
        width: 50%;
        min-width: 200px;
    }

    .actions-column {
        width: 120px;
        min-width: 120px;
    }

    .table-row:hover {
        background-color: rgba(0, 0, 0, 0.02);
        transition: background-color 0.2s ease;
    }

    :deep(.v-card-title) {
        padding: 16px 24px;
    }

    :deep(.v-table) {
        border-radius: 8px;
    }

    :deep(.v-table th) {
        background-color: #f8f9fa;
        font-weight: 600;
        color: #2c3e50;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    :deep(.v-table td) {
        border-bottom: 1px solid #e0e0e0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .gap-2 {
       gap: 8px;
    }

    :deep(.v-autocomplete .v-field) {
        min-height: 56px;
    }

    :deep(.v-autocomplete .v-field__input) {
        padding-top: 8px;
    }

    /* CORREÇÕES SIMPLIFICADAS PARA O DATEPICKER */
    :deep(.date-time-card) {
        min-width: 328px;
    }

    :deep(.date-time-tabs) {
        min-height: 48px;
    }

    :deep(.date-time-actions) {
        padding: 8px 16px;
        border-top: 1px solid #e0e0e0;
    }

    :deep(.date-time-field .v-field) {
        cursor: pointer;
    }

    :deep(.date-time-field .v-field__input) {
        cursor: pointer;
    }

    /* REMOVIDAS TODAS AS LIMITAÇÕES DE ALTURA */
    /* O Vuetify vai controlar automaticamente a altura */

    .width-20 :deep(.v-field) {
        width: 100%;
    }

    @media (max-width: 1200px) {
        .form-grid-proportional {
            gap: 8px;
        }
        
        .width-10 {
            flex: 0 0 calc(15% - 7px);
            max-width: calc(15% - 7px);
        }
        
        .width-20 {
            flex: 0 0 calc(25% - 7px);
            max-width: calc(25% - 7px);
        }
        
        .width-40 {
            flex: 0 0 calc(50% - 7px);
            max-width: calc(50% - 7px);
        }
        
        .width-50 {
            flex: 0 0 calc(50% - 7px);
            max-width: calc(50% - 7px);
        }
    }

    @media (max-width: 960px) {
        .cadastro-negociacoes {
            padding: 16px;
        }
      
        .form-grid-proportional {
            flex-direction: column;
            gap: 12px;
        }
        
        .width-10,
        .width-20,
        .width-25,
        .width-40,
        .width-50 {
            flex: 0 0 100%;
            max-width: 100%;
        }
        
        .proportional-table {
            table-layout: auto;
        }
        
        .column-width-10,
        .column-width-20,
        .column-width-25,
        .column-width-40,
        .column-width-50 {
            width: auto;
            min-width: 100px;
        }

        :deep(.date-time-card) {
            min-width: 300px;
            max-width: 90vw;
        }
    }

    @media (max-width: 600px) {
        .cadastro-negociacoes {
            padding: 12px;
        }
        
        :deep(.v-card-title .text-h5) {
            font-size: 1.25rem;
        }
        
        .table-container {
            font-size: 0.875rem;
        }
        
        .actions-column {
            width: 100px;
            min-width: 100px;
        }
        
        :deep(.date-time-card) {
            min-width: 280px;
            max-width: 95vw;
        }
    }

    @media (min-width: 1600px) {
        .form-grid-proportional {
            max-width: 1400px;
            margin: 0 auto;
        }
    }

    .disabled-field {
        opacity: 0.6;
        cursor: not-allowed;
    }

    /* Opcional: estilizar o editor quando desabilitado */
    .disabled-field .tiptap-editor {
        pointer-events: none;
        background-color: #f5f5f5;
    }    
</style>

<style>

    /* Estilos para campos desabilitados no Quill Editor */
    .campos-desabilitados .quill-editor-wrapper :deep(.ql-toolbar),
    .campos-desabilitados .quill-editor-wrapper :deep(.ql-container) {
        background-color: #f5f5f5;
        opacity: 0.8;
    }

    .campos-desabilitados .quill-editor-wrapper :deep(.ql-editor) {
        color: #000000 !important;
    }
    
    /* Aplica o tamanho da fonte ao container principal do editor */
    .ql-container {
        font-size: 18px; /* Altere para o tamanho desejado */
    }

    /* Garante que a área de edição herde o tamanho da fonte */
    .quill-editor-wrapper :deep(.ql-editor) {
        font-size: 18px; /* Altere para o tamanho desejado */
    }

</style>